import { Box, Typography } from "@mui/material";
import type { Dispatch, FC, SetStateAction } from "react";
import { SystemSwitch } from "@/ui/Clickable/SystemSwitch";

type Props = {
	version: "new" | "old";

	onVersionChange: ((version: "new" | "old") => void) | Dispatch<SetStateAction<"new" | "old">>;
};
export const RecurringModalVersionToggle: FC<Props> = ({ onVersionChange, version }) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
			}}
		>
			<Typography>Version 1.0</Typography>
			<SystemSwitch checked={version === "new"} onChange={(event) => onVersionChange(event.target.checked ? "new" : "old")} />
			<Typography>Version 2.0</Typography>
		</Box>
	);
};
